export default "__VITE_ASSET__Ce5G3OP___"